/* eslint-disable @typescript-eslint/no-explicit-any */
import {useFormik} from "formik";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "@/store";
import {StoreUtil} from "@/util/store/StoreUtil.ts";
import {notification} from "@/store/modules/notification.ts";
import {BaseInput} from "../input/BaseInput.tsx";
import {BaseSelect} from "../input/BaseSelect.tsx";
import {CreateAttribute, CreateAttributeInit} from "@/model/request/attribute/CreateAttribute.ts";
import {attribute} from "@/store/modules/attribute.ts";
import {useState} from "react";
import {NewModuleType} from "./NewApplicationForm.tsx";
import {BaseResponse} from "@/model/response/BaseResponse.ts";
import {AttributeValidation} from "@/components/formik/validation/AttributeValidation.ts";

export default function NewAttributeForm({onClose, data}: NewModuleType) {
    const dispatch = useDispatch<any>();
    const entityState = useSelector((state: RootState) => state.entity);
    const attributeState = useSelector((state: RootState) => state.attribute);
    // const [inputValue, setInputValue] = useState("");
    // const [items, setItems] = useState<string[]>([]);
    const [selectedValue, setSelectedValue] = useState("")


    // const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    //     if (e.key === "Enter" && inputValue.trim()) {
    //         setItems((prev) => [...prev, inputValue.trim()]);
    //         setInputValue(""); // Clear the input
    //     } else if (e.key === "Backspace" && !inputValue) {
    //         setItems((prev) => prev.slice(0, -1));
    //     }
    // };


    // const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    //     if (e.key === "Enter" && inputValue.trim()) {
    //         console.log("Adding:", inputValue.trim()); // Debugging log
    //         // Add the current input to the list
    //         setItems(() => [...items, inputValue.trim()]);
    //         setInputValue(""); // Clear the input field
    //     } else if (e.key === "Backspace" && !inputValue) {
    //         console.log("Removing last item"); // Debugging log
    //         // Remove the last item if input is empty
    //         setItems((prev) => prev.slice(0, -1));
    //     }
    // };

    // const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    //     if (e.key === "Escape" && inputValue.trim()) {
    //         setItems((prev) => {
    //             const newItem = [...prev, inputValue.trim()]
    //             return newItem;
    //         });
    //         setInputValue(""); // Clear the input
    //     } else if (e.key === "Backspace" && !inputValue) {
    //         setItems((prev) => prev.slice(0, -1)); // Remove last item
    //     }
    // };

    // const handleRemoveItem = (itemToRemove: string) => {
    //     setItems((prev) => prev.filter((item) => item !== itemToRemove));
    // };


    // const handleRemoveItem = (itemToRemove: string) => {
    //     setItems((prev) => prev.filter((item) => item !== itemToRemove));
    // };
    // useEffect(() => {
    //     dispatch(attribute.mutation.setLoading(false))
    // }, []);

    // const showMessage = (
    //     response: any,
    //     title: "error" | "success" = "success",
    //     type: "error" | "success" = "success"
    // ) => {
    //     StoreUtil.execute(() => {
    //             dispatch(
    //                 notification.mutation.openModal({
    //                     type: type,
    //                     title: title,
    //                     body: response.responseMessage,
    //                 })
    //             )
    //             dispatch(attribute.action.readAttributeByEntityId({attributeEntityId: entityState?.selectedEntity?.entityId ? entityState?.selectedEntity?.entityId : 0}))
    //         }
    //     );
    //     // dispatch(base.mutation.resetModalOptions())
    //     formik.resetForm()
    // };

    const showMessage = (response: any) => {
        StoreUtil.execute(() => {
                dispatch(
                    notification.mutation.openModal({
                        type: "success",
                        title: "Success",
                        body: response.responseMessage,
                    })
                )
                dispatch(attribute.action.readAttributeByEntityId({attributeEntityId: entityState?.selectedEntity?.entityId ? entityState?.selectedEntity?.entityId : 0}))
            }
        );
        onClose()
    };

    const showErrorMessage = (response: BaseResponse) => {
        StoreUtil.execute(() =>
            dispatch(
                notification.mutation.openModal({
                    type: "error",
                    title: "Error",
                    body: response.responseMessage,
                })
            )
        );
    };

    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedLabel = event.target.options[event.target.selectedIndex].label
        setSelectedValue(selectedLabel);
        const selectedValue = Number(event.target.value);
        dispatch(attribute.action.readAttributeByEntityId({attributeEntityId: selectedValue}));
    };

    const handleSubmit = async (value: CreateAttribute) => {
        const updatedRequest = {
            ...value, attributeEntityId: entityState?.selectedEntity?.entityId, attributeValueList: "",
            attributeId: data?.attributeId, attributeStatus: data?.attributeStatus,
        }
        const request = {
            ...value,
            attributeEntityId: entityState?.selectedEntity?.entityId,
            attributeReferenceAttribute: formik.values.attributeReferenceAttribute ? formik.values.attributeReferenceAttribute : null,
            attributeReferenceEntity: selectedValue || null,
            attributeValueList: "default"
        }
        data ? dispatch(attribute.action.updateAttribute({
            data: updatedRequest,
            onSuccess: (response: BaseResponse) => showMessage(response),
            onError: (response: BaseResponse) => showMessage(response),

        })) : dispatch(attribute.action.createAttribute({
            data: request,
            onSuccess: (response: BaseResponse) => showMessage(response),
            onError: (response: BaseResponse) => showErrorMessage(response),
        }))
    };

    const formik = useFormik({
        onSubmit: handleSubmit,
        initialValues: data ? data : CreateAttributeInit,
        validationSchema: AttributeValidation.create,
    });

    return (
        <>
            <form onSubmit={formik.handleSubmit}>
                <div className="div-block-4">
                    <label htmlFor="applicationName" className="field-label">
                        Name
                    </label>
                    <BaseInput
                        formik={formik}
                        className="form_input w-input"
                        maxLength={256}
                        name={"attributeName"}
                        data-name="attributeName"
                        placeholder=""
                        type="text"
                        id="attributeName"
                    />
                </div>
                <div className="div-block-4">
                    <label htmlFor="name-2" className="field-label">
                        Default Value
                    </label>
                    <BaseInput
                        formik={formik}
                        className="form_input w-input"
                        maxLength={256}
                        name="attributeDefaultValue"
                        data-name="attributeDefaultValue"
                        placeholder=""
                        type="text"
                        id="attributeDefaultValue"
                    />
                </div>
                {/*<label htmlFor="name-2" className="field-label">*/}
                {/*    Value List*/}
                {/*</label>*/}
                {/*<BaseInput*/}
                {/*    formik={formik}*/}
                {/*    className="form_input w-input"*/}
                {/*    maxLength={256}*/}
                {/*    name="attributeValueList"*/}
                {/*    data-name="attributeValueList"*/}
                {/*    placeholder=""*/}
                {/*    type="text"*/}
                {/*    id="attributeValueList"*/}
                {/*/>*/}
                ` <div className="div-block-4">
                <label htmlFor="name-2" className="field-label">
                    Start Value
                </label>
                <BaseInput
                    formik={formik}
                    className="form_input w-input"
                    maxLength={256}
                    name="attributeStartValue"
                    data-name="attributeStartValue"
                    placeholder=""
                    type="number"
                    id="attributeStartValue"
                />
            </div>
                <div className="div-block-4">
                    <label htmlFor="name-2" className="field-label">
                        Length
                    </label>
                    <BaseInput
                        formik={formik}
                        className="form_input w-input"
                        maxLength={256}
                        name="attributeLength"
                        data-name="attributeLength"
                        placeholder="Attribute Length"
                        type="text"
                        id="attributeLength"
                    />
                </div>
                <div className="div-block-4">
                    <label htmlFor="name-2" className="field-label">
                        Test Data
                    </label>
                    <BaseInput
                        formik={formik}
                        className="form_input w-input"
                        maxLength={256}
                        name="attributeTestData"
                        data-name="attributeTestData"
                        placeholder=""
                        type="text"
                        id="attributeTestData"
                    />
                </div>
                <div className="div-block-4">
                    <label htmlFor="name-2" className="field-label">
                        Decimal Limit
                    </label>
                    <BaseInput
                        formik={formik}
                        className="form_input w-input"
                        maxLength={256}
                        name="attributeDecimalLimit"
                        data-name="attributeDecimalLimit"
                        placeholder=""
                        type="text"
                        id="attributeDecimalLimit"
                    />
                </div>


                <div className="div-flex">
                    <div style={{width: "50%"}}>
                        <label htmlFor="name-2" className="field-label">
                            Auto Increment
                        </label>
                        <BaseSelect
                            formik={formik}
                            className="form_input w-select"
                            name="attributeAutoIncrement"
                            data-name="attributeAutoIncrement"
                            id="attributeAutoIncrement"
                            items={[
                                {value: "", label: "Select Value", disabled: true},
                                {value: "Yes", label: "Yes"},
                                {value: "No", label: "No"},
                            ]}
                        />
                    </div>
                    <div style={{width: "50%"}}>
                        <label htmlFor="name-2" className="field-label">
                            Primary Key
                        </label>
                        <BaseSelect
                            formik={formik}
                            className="form_input w-select"
                            name="attributePrimaryKey"
                            data-name="attributePrimaryKey"
                            id="attributePrimaryKey"
                            items={[
                                {value: "", label: "Select Value", disabled: true},
                                {value: "Yes", label: "Yes"},
                                {value: "No", label: "No"},
                            ]}
                        />
                    </div>
                </div>
                <div className="div-flex">
                    <div style={{width: "50%"}}>
                        <label htmlFor="name-2" className="field-label">
                            Foreign Key
                        </label>
                        <BaseSelect
                            formik={formik}
                            className="form_input w-select"
                            name="attributeForeignKey"
                            data-name="attributeForeignKey"
                            id="attributeForeignKey"
                            items={[
                                {value: "", label: "Select Value", disabled: true},
                                {value: "Yes", label: "Yes"},
                                {value: "No", label: "No"},
                            ]}
                        />
                    </div>
                    <div style={{width: "50%"}}>
                        <label htmlFor="name-2" className="field-label">
                            Null
                        </label>
                        <BaseSelect
                            formik={formik}
                            className="form_input w-select"
                            name="attributeNull"
                            data-name="attributeNull"
                            id="attributeNull"
                            items={[
                                {value: "", label: "Select Value", disabled: true},
                                {value: "Yes", label: "Yes"},
                                {value: "No", label: "No"},
                            ]}
                        />
                    </div>
                </div>
                <div className="div-flex">
                    <div className="div-block-4" style={{width: "50%"}}>
                        <label htmlFor="name-2" className="field-label">
                            Data Type
                        </label>
                        <BaseSelect
                            formik={formik}
                            className="form_input w-input"
                            name="attributeDataType"
                            data-name="attributeDataType"
                            id="attributeDataType"
                            items={[{value: "", label: "Select Value", disabled: true},
                                {value: "Int", label: "Int"},
                                {value: "Datetime", label: "Datetime"},
                                {value: "String", label: "String"},
                            ]}
                        />
                    </div>
                    <div style={{width: "50%"}}>
                        <label htmlFor="name-2" className="field-label">
                            Unique
                        </label>
                        <BaseSelect
                            formik={formik}
                            className="form_input w-select"
                            name="attributeUnique"
                            data-name="attributeUnique"
                            id="attributeUnique"
                            items={[
                                {value: "", label: "Select Value", disabled: true},
                                {value: "Yes", label: "Yes"},
                                {value: "No", label: "No"},
                            ]}
                        />
                    </div>
                </div>
                <div className="div-flex">
                    <div className="div-block-4" style={{width: "50%"}}>
                        <label htmlFor="name-2" className="field-label">
                            Required Create
                        </label>
                        <BaseSelect
                            formik={formik}
                            className="form_input w-input"
                            name="attributeIsRequiredCreate"
                            data-name="attributeIsRequiredCreate"
                            id="attributeIsRequiredCreate"
                            items={[
                                {value: "", label: "Select Value", disabled: true},
                                {value: "Yes", label: "Yes"},
                                {value: "No", label: "No"},
                            ]}
                        />
                    </div>
                    <div style={{width: "50%"}}>
                        <label htmlFor="name-2" className="field-label">
                            Required Delete
                        </label>
                        <BaseSelect
                            formik={formik}
                            className="form_input w-select"
                            name="attributeIsRequiredDelete"
                            data-name="attributeIsRequiredDelete"
                            id="attributeIsRequiredDelete"
                            items={[
                                {value: "", label: "Select Value", disabled: true},
                                {value: "Yes", label: "Yes"},
                                {value: "No", label: "No"},
                            ]}
                        />
                    </div>
                </div>
                <div className="div-flex">
                    <div className="div-block-4" style={{width: "50%"}}>
                        <label htmlFor="name-2" className="field-label">
                            Required Update
                        </label>
                        <BaseSelect
                            formik={formik}
                            className="form_input w-input"
                            name="attributeIsRequiredUpdate"
                            data-name="attributeIsRequiredUpdate"
                            id="attributeIsRequiredUpdate"
                            items={[
                                {value: "", label: "Select Value", disabled: true},
                                {value: "Yes", label: "Yes"},
                                {value: "No", label: "No"},
                            ]}
                        />
                    </div>
                    <div style={{width: "50%"}}>
                        <label htmlFor="name-2" className="field-label">
                            Attribute Reference Entity
                        </label>
                        <select className="form_input w-select" onChange={handleChange}
                                disabled={entityState.loading} name="attributeReferenceEntity">
                            <option value={""}>Select Entity</option>
                            {entityState.entityById.map(item =>
                                <option value={item.entityId}>{item.entityName}</option>
                            )}
                        </select>
                        {/*<BaseSelect*/}
                        {/*    formik={formik}*/}
                        {/*    className="form_input w-select"*/}
                        {/*    name="attributeReferenceEntity"*/}
                        {/*    data-name="attributeReferenceEntity"*/}
                        {/*    id={"userId"}*/}
                        {/*    items={[*/}
                        {/*        {value: "", label: "Select User",},*/}
                        {/*        ...entityState.entityById.map(item => {*/}
                        {/*            return {*/}
                        {/*                value: item.entityId,*/}
                        {/*                label: item.entityName,*/}
                        {/*            }*/}
                        {/*        })*/}
                        {/*    ]}*/}
                        {/*/>*/}
                    </div>
                </div>
                <div className="div-flex">
                    <div style={{width: "50%"}}>
                        <label htmlFor="name-2" className="field-label">
                            Attribute Reference
                        </label>
                        <BaseSelect
                            formik={formik}
                            className="form_input w-select"
                            name="attributeReferenceAttribute"
                            data-name="attributeReferenceAttribute"
                            id="attributeReferenceAttribute"
                            items={attributeState.attributeById ? [
                                {value: "", label: "Select Attribute",},
                                ...attributeState.attributeById.map(item => {
                                    return {
                                        value: item.attributeName,
                                        label: item.attributeName,
                                    }
                                })
                            ] : [
                                {value: "", label: "No Attribute"}]}
                            disabled={!attributeState.attributeById!}
                        />
                    </div>
                </div>
                <div className="div-block-5 div-flex">
                    <BaseInput
                        type="submit"
                        formik={formik}
                        className="button w-button"
                        loading={attributeState.loading}
                        value={data ? "Update attribute" : "Add new attribute"}
                        id="new entity"
                    />
                    <a className="button is-secondary w-button" onClick={onClose}>Cancel</a>
                </div>
            </form>
        </>
    );
}


// "attributeReferenceAttribute": "string",
// "attributeReferenceEntity": "string",
// "attributeStep": 0,
